import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';
const UserId = 'userId';
const  InstanceId  ="instanceId"
export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token, expires = 7) {
    // 默认失效时间为7天
    return Cookies.set(TokenKey, token, { expires });
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}

export function getInstanceId() {
    return Cookies.get('instanceId');
}

//保存实例id
export function setInstanceId(instanceId) {
    return Cookies.set('instanceId', instanceId);
}




export function removeInstanceId() {
    return Cookies.remove(InstanceId);
}

export function getUserId() {
    return Cookies.get(UserId);
}

export function setUserId(userId) {
    return Cookies.set(UserId, userId);
}

export function removeUserId() {
    return Cookies.remove(UserId);
}
